import Vue from 'vue';

const EventBus = new Vue();

export {
  EventBus, // eslint-disable-line import/prefer-default-export
};
